// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fGdt","comment":"styles_comment__3zHKm"};